import _ from 'lodash'
import Mustache from 'mustache'

import { formatNumber } from 'core/service/lib/number-format'
import { christianToThaiDate } from 'core/service/lib/date'
import riderMessages from 'core/data-model/constants/validation-messages'
import { isCheckRiderCampaignDiscountActive } from 'core/service/rider/rider'

export const checkRiderCampaignInformationRule = (rule, eligibilities) => {
  let errorMessage = ''
  const isRiderCampaignDiscountActive = isCheckRiderCampaignDiscountActive(
    eligibilities.rider,
    eligibilities.userAgentType
  )

  if (isRiderCampaignDiscountActive) {
    const riderCoverageInformationMessage = _.get(
      eligibilities.rider.campaignDiscount,
      'campaignDiscountMessage.riderCoverageInformationMessage'
    )

    if (riderCoverageInformationMessage) {
      errorMessage = Mustache.render(riderCoverageInformationMessage, {
        premiumDiscount: formatNumber(_.get(eligibilities, 'rider.premium', 0), 2),
        campaignStartDate: _.get(eligibilities.rider.campaignDiscount, 'startDate')
          ? christianToThaiDate(_.get(eligibilities.rider.campaignDiscount, 'startDate'), 'DD/MM/YYYY')
          : '',
        campaignEndDate: _.get(eligibilities.rider.campaignDiscount, 'endDate')
          ? christianToThaiDate(_.get(eligibilities.rider.campaignDiscount, 'endDate'), 'DD/MM/YYYY')
          : '',
      })
    } else {
      errorMessage = riderMessages.RULE_MESSAGE_NOT_FOUND
    }
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
